import { useFetchUser } from '@/auth/hooks';
import { hasTextContent } from '@/lib/markdown-code-utils';
import { explorerAnalytics } from '@/lib/analytics';
import parseHtml from 'html-react-parser';
import CopyButton from './CopyButton';

interface HtmlCodeBlockProps {
  language: string;
  htmlContent: string;
  fallbackText: string;
}

const HtmlCodeBlock: React.FC<HtmlCodeBlockProps> = ({
  language,
  htmlContent,
  fallbackText,
}) => {
  const { isLoggedIn } = useFetchUser();
  const hasHTMLContent = hasTextContent(htmlContent);
  if (!hasHTMLContent) return null;

  return (
    <div className="relative overflow-hidden rounded-md border border-gray-200 dark:border-gray-700 my-4">
      <div className="flex items-center justify-between px-4 py-2 bg-gray-800 text-gray-200">
        <span className="text-sm font-mono">{language}</span>
        {/* Passing the fallback text to copy the actual content instead of converted HTML */}
        <CopyButton
          content={fallbackText}
          onCopied={() => {
            explorerAnalytics.aiCodeCopied({
              language: language || '',
              codeLength: fallbackText?.length || 0,
              isLoggedIn: !!isLoggedIn,
            });
          }}
        />
      </div>
      <div className="overflow-x-auto">
        {htmlContent ? (
          parseHtml(htmlContent)
        ) : (
          <pre>
            <code>{fallbackText}</code>
          </pre>
        )}
      </div>
    </div>
  );
};

export default HtmlCodeBlock;
